import { render, staticRenderFns } from "./RadioButtonsElement.vue?vue&type=template&id=8fedc684&scoped=true&"
import script from "./RadioButtonsElement.vue?vue&type=script&lang=ts&"
export * from "./RadioButtonsElement.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButtonsElement.vue?vue&type=style&index=0&id=8fedc684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fedc684",
  null
  
)

export default component.exports